import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Card } from 'antd'
import React, { memo, useCallback, useState } from 'react'
import fitnessImage from '../../../../../assets/Mobile app/Fitness.jpg'
import mentalHealthImage from '../../../../../assets/Mobile app/Mental Health.jpg'
import nutritionImage from '../../../../../assets/Mobile app/Nutrition.jpg'
import sleepImage from '../../../../../assets/Mobile app/Sleep.jpg'
import '../styling/MobTrending.css'
import InfoSlider from './InfoSlider'

const MobTrending = memo(() => {
  const [selectedCard, setSelectedCard] = useState(null)

  const cards = [
    {
      id: 'mental-health',
      title: 'Mental health',
      description: 'Prioritize your mental wellbeing with our resources.',
      color: '#5E35B1', // Deep Purple
      image: mentalHealthImage,
      fullDescription:
        'Take care of your mental health with our comprehensive resources and support system. Access professional guidance, self-help tools, and community support.',
      features: [
        'Professional counseling services',
        'Mental health assessment tools',
        'Stress management resources',
        'Community support groups',
        'Emergency crisis support'
      ]
    },
    {
      id: 'nutrition',
      title: 'Nutrition',
      description: 'Discover personalized nutrition plans for optimal health.',
      color: '#00897B', // Teal
      image: nutritionImage,
      fullDescription:
        'Get personalized nutrition plans tailored to your health goals and dietary preferences. Access expert advice and meal planning tools.',
      features: [
        'Personalized meal plans',
        'Nutritional tracking',
        'Dietary restriction support',
        'Recipe database',
        'Nutritionist consultations'
      ]
    },
    {
      id: 'fitness',
      title: 'Fitness',
      description: 'Exercise programs tailored to your health goals.',
      color: '#F57C00', // Orange
      image: fitnessImage,
      fullDescription:
        'Achieve your fitness goals with customized exercise programs and professional guidance. Track your progress and stay motivated.',
      features: [
        'Custom workout plans',
        'Exercise video library',
        'Progress tracking',
        'Personal trainer support',
        'Fitness community'
      ]
    },
    {
      id: 'sleep',
      title: 'Sleep',
      description: 'Improve your sleep quality with expert guidance.',
      color: '#3949AB', // Indigo
      image: sleepImage,
      fullDescription:
        'Enhance your sleep quality with expert guidance and personalized recommendations. Track your sleep patterns and get insights.',
      features: [
        'Sleep tracking',
        'Sleep hygiene tips',
        'Relaxation techniques',
        'Sleep analysis reports',
        'Expert sleep advice'
      ]
    }
  ]

  const handleCardClick = useCallback((card) => {
    setSelectedCard(card)
  }, [])

  const handleCloseSlider = useCallback(() => {
    setSelectedCard(null)
  }, [])

  return (
    <div className='trending-container'>
      <h2
        style={{
          textAlign: 'left',
          fontSize: 18,
          color: '#000000',
          fontWeight: 500,
          margin: '0 0 16px 0',
          padding: '0 0 0 4px'
        }}
      >
        Trending
      </h2>

      <div className='trending-carousel'>
        <div className='trending-cards'>
          {cards.map((card) => (
            <div
              key={card.id}
              className='card-wrapper'
              style={{ width: '55%', minWidth: 160, marginRight: 10, flexShrink: 0 }}
              onClick={() => handleCardClick(card)}
              role='button'
              tabIndex={0}
              onKeyPress={(e) => e.key === 'Enter' && handleCardClick(card)}
              aria-label={`Learn more about ${card.title}`}
            >
              <Card
                className='trending-card'
                style={{
                  borderRadius: '12px',
                  overflow: 'hidden',
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                  border: 'none',
                  width: '100%',
                  height: 120,
                  padding: 0,
                  marginBottom: 8
                }}
                bodyStyle={{ padding: 0 }}
              >
                <div
                  className='card-image-container'
                  style={{
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                    backgroundColor: '#f5f5f5'
                  }}
                >
                  {card.image ? (
                    <img
                      src={card.image}
                      alt={card.title}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        color: '#CCCCCC',
                        fontSize: 12,
                        fontStyle: 'italic'
                      }}
                    >
                      Image coming soon
                    </div>
                  )}
                </div>
              </Card>
              <div className='card-text-content'>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: 4
                  }}
                >
                  <h3
                    style={{
                      fontSize: 15,
                      fontWeight: 600,
                      marginTop: 0,
                      marginBottom: 0,
                      marginRight: 4,
                      color: card.color
                    }}
                  >
                    {card.title}
                  </h3>
                  <FontAwesomeIcon
                    icon={faArrowRight}
                    style={{
                      fontSize: 10,
                      color: card.color
                    }}
                  />
                </div>
                <p
                  style={{
                    fontSize: 12,
                    color: '#444444',
                    lineHeight: 1.3,
                    margin: 0
                  }}
                >
                  {card.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <InfoSlider
        isOpen={!!selectedCard}
        onClose={handleCloseSlider}
        title={selectedCard?.title || ''}
        description={selectedCard?.fullDescription || ''}
        features={selectedCard?.features || []}
      />
    </div>
  )
})

MobTrending.displayName = 'MobTrending'

export default MobTrending
